const listeners = /* @__PURE__ */ new Set();
let reportActive = false;
let lastReport = Date.now();
function reportResize() {
  listeners.forEach((listener) => listener(!reportActive));
}
const MIN_REPORT_INTERVAL = 100;
function resizeReporterThread() {
  if (Date.now() - lastReport >= MIN_REPORT_INTERVAL) {
    reportResize();
    lastReport = Date.now();
  } else if (!reportActive) {
    reportResize();
  }
  if (reportActive)
    requestAnimationFrame(resizeReporterThread);
}
let debounceID = -1;
function handleResizeEvent() {
  clearTimeout(debounceID);
  if (!reportActive)
    requestAnimationFrame(resizeReporterThread);
  reportActive = true;
  debounceID = window.setTimeout(
    () => reportActive = false,
    MIN_REPORT_INTERVAL * 2
  );
}
function addResizeListener(listener) {
  if (listeners.has(listener))
    return;
  if (listeners.size === 0)
    window.addEventListener("resize", handleResizeEvent);
  listeners.add(listener);
}
function removeResizeListener(listener) {
  if (!listeners.has(listener))
    return;
  listeners.delete(listener);
  if (listeners.size === 0)
    window.removeEventListener("resize", handleResizeEvent);
}
export {
  addResizeListener,
  removeResizeListener
};
